import Vue from 'vue'
import router from '@/router'
import api from '@/api/index'
import config from '@/config/index'

const state = {
  menus: [
    {
      id: '1',
      name: '平台设置',
      code: '1',
      opened: false,
      redirectTo: '/platform/dictList',
      children: [{
        id: '11',
        parentId: '1',
        name: '字典管理',
        code: '11',
        redirectTo: '/platform/dictList'
      }]
    }
  ]
}

const actions = {
}
const mutations = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/sysmenus.js